/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';
import type { SignatoryViewModel } from './SignatoryViewModel';
import {
    SignatoryViewModelFromJSON,
    SignatoryViewModelFromJSONTyped,
    SignatoryViewModelToJSON,
} from './SignatoryViewModel';

/**
 * 
 * @export
 * @interface ResultOfSignatoryViewModel
 */
export interface ResultOfSignatoryViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfSignatoryViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfSignatoryViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfSignatoryViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfSignatoryViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfSignatoryViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfSignatoryViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfSignatoryViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {SignatoryViewModel}
     * @memberof ResultOfSignatoryViewModel
     */
    data?: SignatoryViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfSignatoryViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfSignatoryViewModel interface.
 */
export function instanceOfResultOfSignatoryViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfSignatoryViewModelFromJSON(json: any): ResultOfSignatoryViewModel {
    return ResultOfSignatoryViewModelFromJSONTyped(json, false);
}

export function ResultOfSignatoryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfSignatoryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : SignatoryViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfSignatoryViewModelToJSON(value?: ResultOfSignatoryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': SignatoryViewModelToJSON(value.data),
        'Count': value.count,
    };
}

